import React from 'react';
import { Link } from 'react-router-dom';
import { RemoteImg } from './RemoteMedia';

export default function CardItem({ to, title, subtitle, meta, image, imageAlt, badge, progress = 0, buttonLabel = 'Học ngay', disabled=false, onClick, actions, noLink=false, linkState, isVipLocked=false, 
  streakDaysDone, streakDaysGoal, streakHoursDone, streakHoursGoal, streakSessions,
  lessonGoalDays, lessonGoalHours, lessonDuration,
  courseGoalDays, courseGoalHours
}) {
  const Container = (!disabled && !noLink) ? Link : 'div';
  const containerProps = (!disabled && !noLink) ? { to: to || '#', state: linkState } : {};
  return (
    <Container {...containerProps} className="block h-full" onClick={disabled ? onClick : undefined}>
      <div className={`bg-[#0f1e35] rounded-xl shadow-lg hover:shadow-2xl transition-all duration-200 p-4 sm:p-5 h-full flex flex-col cursor-pointer group-hover:-translate-y-0.5 ${
        isVipLocked 
          ? 'border-2 border-amber-400/40 hover:border-amber-400/60 shadow-amber-500/20 hover:shadow-amber-500/30 bg-gradient-to-br from-[#0f1e35] via-[#0f1e35] to-amber-950/20' 
          : 'border border-white/10 hover:border-white/20'
      }`}>
        {/* Top section: image + info */}
        <div className="flex items-start gap-3 sm:gap-4 flex-1">
          {image ? (
            <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
              <RemoteImg src={image} width={80} alt={imageAlt || title} className="object-cover w-full h-full" />
            </div>
          ) : (
            <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-lg bg-gray-100" />
          )}

            <div className="flex-1 min-w-0">
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0 flex-1">
                <h3 className="text-base sm:text-lg font-bold text-white leading-tight line-clamp-2">{title}</h3>
                {subtitle ? <p className="text-xs sm:text-sm text-gray-400 mt-1 line-clamp-2">{subtitle}</p> : null}
                {/* Per-lesson goals and studied time */}
                {(typeof courseGoalDays !== 'undefined' || typeof courseGoalHours !== 'undefined' || typeof lessonGoalDays !== 'undefined' || typeof lessonGoalHours !== 'undefined' || typeof lessonDuration !== 'undefined') && (
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {((typeof courseGoalDays !== 'undefined' || typeof courseGoalHours !== 'undefined') || (typeof lessonGoalDays !== 'undefined' || typeof lessonGoalHours !== 'undefined')) && (
                      <div className="text-xs text-gray-300 bg-white/5 px-2 py-1 rounded-full">Mục tiêu: <span className="text-white font-semibold">{(typeof courseGoalDays !== 'undefined' && courseGoalDays !== null) ? courseGoalDays : (lessonGoalDays || 0)} ngày</span>{((typeof courseGoalHours !== 'undefined' && courseGoalHours !== null) ? courseGoalHours : lessonGoalHours) ? <span className="text-gray-400"> · {((typeof courseGoalHours !== 'undefined' && courseGoalHours !== null) ? courseGoalHours : lessonGoalHours)} giờ</span> : null}</div>
                    )}
                    {typeof lessonDuration !== 'undefined' && (
                      <div className="text-xs text-gray-300 bg-white/5 px-2 py-1 rounded-full">Thời lượng: <span className="text-white font-semibold">{(function(s){ if(!s||isNaN(s)) return '0:00'; const sec=Math.floor(s); const h=Math.floor(sec/3600); const m=Math.floor((sec%3600)/60); const ss=sec%60; if(h>0) return `${h}:${String(m).padStart(2,'0')}:${String(ss).padStart(2,'0')}`; return `${m}:${String(ss).padStart(2,'0')}`})(lessonDuration)}</span></div>
                    )}
                  </div>
                )}
              </div>
              {badge ? (
                <span className={`shrink-0 text-xs px-2 py-0.5 rounded-full shadow-sm font-semibold ${
                  isVipLocked 
                    ? 'bg-gradient-to-r from-amber-500 to-yellow-500 text-white shadow-amber-500/50' 
                    : 'bg-blue-500/20 text-blue-400'
                }`}>
                  {isVipLocked ? '👑 ' : ''}{badge}
                </span>
              ) : null}
            </div>
          </div>
        </div>

        {/* Progress bar */}
        <div className="mt-3">
          <div className="w-full bg-white/10 rounded-full h-1.5">
            <div className="bg-blue-500 h-1.5 rounded-full transition-all" style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}></div>
          </div>
        </div>

        {/* Bottom section: meta + buttons */}
        <div className="mt-3 pt-3 border-t border-white/10">
          {meta && !actions && <p className="text-xs text-gray-500 mb-2">{meta}</p>}
          <div className="flex items-center justify-between gap-2">
            <div className="flex-1 min-w-0">{actions && actions}</div>
            {!actions && (
              <div className="flex items-center gap-2 shrink-0">
                {disabled ? (
                  <button onClick={(e)=>{e.preventDefault(); e.stopPropagation(); onClick && onClick();}} className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg shadow text-sm">{buttonLabel}</button>
                ) : (
                  (noLink && to) ? (
                    <Link to={to} state={linkState} onClick={(e)=>e.stopPropagation()}>
                      <button className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg shadow text-sm">{buttonLabel}</button>
                    </Link>
                  ) : (
                    <button className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg shadow text-sm">{buttonLabel}</button>
                  )
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}
